import React from 'react';
import { useDispatch } from 'react-redux';
import { updateBlog } from '../features/blog/blogSlice';

const SingleBlog = ({ blog }) => {
  const { id, image, title, description, likes, isSaved, tags } = blog;
  const dispatch = useDispatch();

  const tagContent = tags.map((tag, idx) => {
    if (tags.length === idx + 1) return <span key={idx}>#{tag}</span>;
    return <span key={idx}>#{tag}, </span>;
  });

  return (
    <main className="post">
      <img
        src={image}
        alt={title}
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tagContent}
        </div>
        <div className="btn-group">
          <button
            className="like-btn"
            id="lws-singleLinks"
            onClick={() =>
              dispatch(updateBlog({ id, data: { likes: likes + 1 } }))
            }
          >
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>

          <button
            className={`${isSaved ? 'active' : ''} save-btn`}
            id="lws-singleSavedBtn"
            onClick={() =>
              dispatch(updateBlog({ id, data: { isSaved: !isSaved } }))
            }
          >
            <i className="fa-regular fa-bookmark"></i>{' '}
            {isSaved ? 'Saved' : 'Save'}
          </button>
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
};

export default SingleBlog;
